export const isGlobalReadAllRole = (userData) => {
  if (!userData) return false;
  const normalizedRole = (userData.Role ?? userData.role ?? '').toString().trim().toLowerCase();
  const roleId = Number(userData.RoleId ?? userData.roleId ?? userData.UserRoleId ?? userData.userRoleId);

  const isSystemAdminByName =
    normalizedRole === 'system admin' ||
    normalizedRole === 'system-admin' ||
    normalizedRole === 'sys admin' ||
    normalizedRole === 'sysadmin';

  return isSystemAdminByName || roleId === 1;
};

const normalizeRoleName = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase();

// System admin o User admin (rol global): pueden operar sobre cualquier entidad.
export const isGlobalManageRole = (userData) => {
  if (!userData) return false;
  const normalizedRole = normalizeRoleName(userData.Role ?? userData.role);
  const roleId = Number(userData.RoleId ?? userData.roleId ?? userData.UserRoleId ?? userData.userRoleId);
  return isGlobalReadAllRole(userData) || normalizedRole === 'user admin' || roleId === 2;
};

// Rol del usuario (Owner/Admin/Viewer en minuscula) sobre una entidad; '' si no se encuentra.
export const getEntityRoleFromUserData = (userData, entityId) => {
  const entities = Array.isArray(userData?.Entities) ? userData.Entities : [];
  const entity = entities.find((item) => Number(item?.EntityId) === Number(entityId));
  return normalizeRoleName(entity?.Rol ?? entity?.Role ?? entity?.role);
};

// Rol del usuario sobre la entidad que contiene el datapoint; '' si el datapoint no esta en ninguna entidad.
export const getEntityRoleForDevice = (userData, deviceCode) => {
  const entities = Array.isArray(userData?.Entities) ? userData.Entities : [];
  const code = Number(deviceCode);
  const entity = entities.find((item) =>
    (item?.Localities || []).some((locality) => (locality?.Devices || []).some((device) => Number(device?.DeviceCode) === code))
  );
  return normalizeRoleName(entity?.Rol ?? entity?.Role ?? entity?.role);
};

export const isManagerEntityRole = (role) => {
  const normalized = normalizeRoleName(role);
  return normalized === 'owner' || normalized === 'admin';
};

// Puede crear/editar dentro de la entidad: rol global de administracion u Owner/Admin de esa entidad.
export const canManageEntity = (userData, entityId) =>
  isGlobalManageRole(userData) || isManagerEntityRole(getEntityRoleFromUserData(userData, entityId));

export const canManageDevice = (userData, deviceCode) =>
  isGlobalManageRole(userData) || isManagerEntityRole(getEntityRoleForDevice(userData, deviceCode));

export default isGlobalReadAllRole;
